import Input from "../../../components/inputs/Input";

type Props = {
	search?: string;
	setSearch: (value?: string) => void;
};

const OrdersSearch = ({ search, setSearch }: Props) => {
	return (
		<Input
			name="search"
			value={search}
			onChange={(e) => {
				e.stopPropagation();
				e.preventDefault();
				setSearch(e.target.value);
			}}
			placeholder="Rechercher"
			w="20rem"
		/>
	);
};

export default OrdersSearch;
